import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle, Timer, ArrowDownToLine, BrainCircuit } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <Timer className="w-6 h-6 text-red-500" data-id="element-138" />,
    title: 'Las gotas tardan',
    desc: 'Las gotas para cólicos tardan hasta 40 minutos en digerirse (demasiado tarde).'
  }, {
    icon: <ArrowDownToLine className="w-6 h-6 text-red-500" data-id="element-139" />,
    title: 'Mecerlo empeora',
    desc: 'Mecerlo verticalmente atrapa el aire en el fondo del estómago por gravedad.'
  }, {
    icon: <BrainCircuit className="w-6 h-6 text-red-500" data-id="element-140" />,
    title: 'Esperar agota',
    desc: 'Esperar a que "se le pase" agota tu salud mental y la de tu pareja.'
  }];
  return <section className="py-20 bg-white" data-id="element-141">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-142">
        <FadeIn data-id="element-143">
          <div className="text-center mb-16" data-id="element-144">
            <h2 className="text-3xl md:text-4xl font-bold text-earth-darker mb-4" data-id="element-145">
              POR QUÉ LAS SOLUCIONES TRADICIONALES FALLAN:
            </h2>
            <div className="w-24 h-1 bg-accent mx-auto rounded-full" data-id="element-146" />
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-147">
          {problems.map((prob, idx) => <FadeIn key={idx} delay={idx * 0.1} className="bg-cream p-8 rounded-2xl border border-earth-light/30 shadow-sm hover:shadow-md transition-shadow" data-id="element-148">
              <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center mb-6" data-id="element-149">
                {prob.icon}
              </div>
              <h3 className="text-xl font-bold text-earth-darker mb-3" data-id="element-150">
                {prob.title}
              </h3>
              <p className="text-earth-dark leading-relaxed" data-id="element-151">{prob.desc}</p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}